(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  document.dispatchEvent(
    new CustomEvent('cart-drawer-overlay:updated', {
      detail: { sectionId: '{{ section.id }}' },
    })
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["high-energy-2-image-slider"] && !Shopify.designMode) return;
  try {
    
  class PzHe2ImageSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.autoScroll = this.dataset.autoScroll === 'true';
      this.dialog = this.querySelector('[data-gallery-dialog]');
      this.track = this.querySelector('.pz-he2-slider__track');
      this.previousButton = this.querySelector('[data-slider-previous]');
      this.nextButton = this.querySelector('[data-slider-next]');
      this.modalImage = this.querySelector('[data-gallery-modal-image]');
      this.closeButton = this.querySelector('[data-gallery-close]');
      this.imageButtons = [...this.querySelectorAll('[data-gallery-image]')];
      this.dragging = false;
      this.suppressClick = false;
      this.onImageClick = (event) => {
        if (this.suppressClick) {
          event.preventDefault();
          this.suppressClick = false;
          return;
        }
        this.openImage(event.currentTarget);
      };
      this.onCloseClick = () => this.dialog?.close();
      this.onDialogClick = (event) => {
        if (event.target === this.dialog) this.dialog.close();
      };
      this.onDialogClose = () => this.classList.remove('is-paused');
      this.onPointerDown = (event) => {
        if (this.autoScroll) return;
        if (event.pointerType !== 'mouse' || event.button !== 0 || !this.track) return;
        this.dragging = true;
        this.dragStartX = event.clientX;
        this.dragStartScroll = this.track.scrollLeft;
        this.track.setPointerCapture(event.pointerId);
        this.track.classList.add('is-dragging');
      };
      this.onPointerMove = (event) => {
        if (!this.dragging || !this.track) return;
        const distance = event.clientX - this.dragStartX;
        if (Math.abs(distance) > 5) this.suppressClick = true;
        this.track.scrollLeft = this.dragStartScroll - distance;
      };
      this.onPointerEnd = (event) => {
        if (!this.dragging || !this.track) return;
        this.dragging = false;
        if (this.track.hasPointerCapture(event.pointerId)) {
          this.track.releasePointerCapture(event.pointerId);
        }
        this.track.classList.remove('is-dragging');
      };
      this.onPrevious = () => this.scrollTrack(-1);
      this.onNext = () => this.scrollTrack(1);
      this.onTrackScroll = () => this.updateNavigation();
      this.onResize = () => this.updateNavigation();
      this.imageButtons.forEach((button) => button.addEventListener('click', this.onImageClick));
      this.closeButton?.addEventListener('click', this.onCloseClick);
      this.dialog?.addEventListener('click', this.onDialogClick);
      this.dialog?.addEventListener('close', this.onDialogClose);
      if (!this.autoScroll) {
        this.track?.addEventListener('pointerdown', this.onPointerDown);
        this.track?.addEventListener('pointermove', this.onPointerMove);
        this.track?.addEventListener('pointerup', this.onPointerEnd);
        this.track?.addEventListener('pointercancel', this.onPointerEnd);
        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track?.addEventListener('scroll', this.onTrackScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        requestAnimationFrame(() => this.updateNavigation());
      }
    }
    disconnectedCallback() {
      this.imageButtons?.forEach((button) => button.removeEventListener('click', this.onImageClick));
      this.closeButton?.removeEventListener('click', this.onCloseClick);
      this.dialog?.removeEventListener('click', this.onDialogClick);
      this.dialog?.removeEventListener('close', this.onDialogClose);
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointermove', this.onPointerMove);
      this.track?.removeEventListener('pointerup', this.onPointerEnd);
      this.track?.removeEventListener('pointercancel', this.onPointerEnd);
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onTrackScroll);
      window.removeEventListener('resize', this.onResize);
      this.initialized = false;
    }
    scrollTrack(direction) {
      if (!this.track) return;
      this.track.scrollBy({
        left: direction * Math.max(320, this.track.clientWidth * 0.8),
        behavior: 'smooth'
      });
    }
    updateNavigation() {
      if (!this.track) return;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
    }
    openImage(button) {
      const preview = button.querySelector('img');
      const source = button.dataset.fullSrc || preview?.currentSrc || preview?.src;
      if (!source || !this.dialog || !this.modalImage) return;
      if (this.autoScroll) this.classList.add('is-paused');
      this.modalImage.src = source;
      this.modalImage.alt = preview?.alt || '';
      this.dialog.showModal();
    }
  }
  if (!customElements.get('pz-he2-image-slider')) {
    customElements.define('pz-he2-image-slider', PzHe2ImageSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
